import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute, buildRoute } from 'appRoutes'
import { McpSettingsPage } from 'features/mcpSettings'
import { getLDFlag } from 'helpers/launchDarkly'
import { canViewConfigurationPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/mcp')({
  component: McpSettingsPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('MCP'),
      },
    ],
  }),
  beforeLoad: async (ctx) => {
    const isMcpSettingsEnabled = getLDFlag('MCP_SETTINGS', false, ctx.context.ldClient)
    if (!isMcpSettingsEnabled) {
      throw redirect({
        to: buildRoute(AppRoute.SubscriptionOverview, { subscriptionId: ctx.params.subscriptionId }),
      })
    }
    await protectWithWorkspacePermissions(canViewConfigurationPermission)(ctx)
  },
})
